import { render } from "./without-feedback.vue?vue&type=template&id=0eba72fa"
import script from "./without-feedback.vue?vue&type=script&lang=js"
export * from "./without-feedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__